import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Grid,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import productThumbnails from '../constants/productThumbnails';

interface CartItem {
  productId: string;
  name: string;
  price: number;
  quantity: number;
  platform?: string;
  hostApp?: string;
  image?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  productName: string;
  productImage: string;
  platform: string;
  hostApp: any;
  quantity: number;
  subtotal: number;
  totalItems: number;
  items: CartItem[];
}

const AddToCartConfirmationModal: React.FC<Props> = ({
  open,
  onClose,
  productName,
  productImage,
  platform,
  hostApp,
  quantity,
  subtotal,
  totalItems,
  items,
}) => {
  console.log('AddToCartConfirmationModal', {
    productName,
    productImage,
    platform,
    hostApp,
    quantity,
    subtotal,
    totalItems,
    items,
  });
  const navigate = useNavigate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        ✅ Product successfully added to your cart
      </DialogTitle>
      <Divider />
      {/* <DialogContent>
        <Typography variant="h6" gutterBottom>
          Current Items in Cart
        </Typography>
        <Box maxHeight={400} overflow="auto">
          {items.map((item) => (
            <Box
              key={item.productId}
              sx={{
                display: 'flex',
                gap: 2,
                alignItems: 'center',
                borderBottom: '1px solid #eee',
                py: 1.5,
              }}
            >
              <img
                src={productThumbnails.get(item.productId.productId)}
                alt={item.name}
                style={{ width: 150, height: 150, objectFit: 'contain' }}
              />
              <Box flex={1}>
                <Typography fontWeight="bold">{item.productId.name}</Typography>
                <Typography variant="body2">
                  Qty: {item.quantity} — ${item.productId.fullPrice.toFixed(2)}
                </Typography>
                {item.platform && (
                  <Typography variant="caption" display="block">
                    Platform: {item.platform}
                  </Typography>
                )}
                {item.hostApplication && (
                  <Typography variant="caption" display="block">
                    Host App: {item.hostApplication.displayName}
                  </Typography>
                )}
              </Box>
            </Box>
          ))}
        </Box>

        <Box mt={3}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography>Items in Cart:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right">{totalItems}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Subtotal:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right">${subtotal.toFixed(2)}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Shipping:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right">Free</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography fontWeight="bold">Total:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography align="right" fontWeight="bold">
                ${subtotal.toFixed(2)}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent> */}
      <DialogContent>
        <Grid container spacing={4}>
          {/* Left Column - Items */}
          <Grid item xs={12} md={8}>
            <Typography variant="h6" gutterBottom>
              Current Items in Cart
            </Typography>
            <Box maxHeight={400} overflow="auto">
              {items.map((item: any) => (
                <Box
                  key={item.productId}
                  sx={{
                    display: 'flex',
                    gap: 2,
                    alignItems: 'center',
                    borderBottom: '1px solid #eee',
                    py: 1.5,
                  }}
                >
                  <img
                    src={productThumbnails.get(item.productId.productId)}
                    alt={item.name}
                    style={{ width: 100, height: 100, objectFit: 'contain' }}
                  />
                  <Box flex={1}>
                    <Typography fontWeight="bold">
                      {item.productId.name}
                    </Typography>
                    <Typography variant="body2">
                      Qty: {item.quantity} — $
                      {item.productId.fullPrice.toFixed(2)}
                    </Typography>
                    {item.platform && (
                      <Typography variant="caption" display="block">
                        Platform: {item.platform}
                      </Typography>
                    )}
                    {item.hostApplication && (
                      <Typography variant="caption" display="block">
                        Host App: {item.hostApplication.displayName}
                      </Typography>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Right Column - Totals */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Order Summary
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Typography>Items in Cart:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="right">{totalItems}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>Subtotal:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="right">${subtotal.toFixed(2)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>Shipping:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="right">Free</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography fontWeight="bold">Total:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography align="right" fontWeight="bold">
                  ${subtotal.toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant="outlined" onClick={() => navigate('/store/video')}>
          Continue Shopping
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/cart/1')}
        >
          Proceed to Checkout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddToCartConfirmationModal;
